import store from '@/store';

export default (to, from, next) => {
  const rootPath = '/';
  const user = store.state.user;
  if (!user && from.name) {
    store.dispatch('changeSignupDialogState', true);
    return false;
  }
  if (!user || typeof user.disabled === 'object') {
    next(rootPath);
  } else {
    next();
  }
};
